module.exports = __webpack_public_path__ + "static/img/atomicmind-grow-logo.b6c873e4.svg";